<template>
  <div class="home-style">
    <rSwiper ref="swiperDOM" class="swiper" @loadEnd="funLoadEnd" @transitionend="funTransitionend" :fast="true">
      <rSlide>
        <div class="box">
          <img src="../../assets/image/home/homeCarousel1.png" alt="" style="width: 100%;height: 100%">
          <!-- <div class="box-content">
            <div class="box-content-title">国内领先的地学云产品与服务商</div>
            <div class="box-content-jianjie">致力于地学智能化产品研发及行业应用</div>
          </div> -->
        </div>
      </rSlide>
      <rSlide>
        <div class="box box2">
          <img src="../../assets/image/home/homebanner2.png" alt="" style="width: 100%;height: 100%">
          <!-- <div class="box-content">
            <div class="box-content-title">矿山安全生产智慧监测管控分析</div>
            <div class="box-content-jianjie">统一标准、统一设计、统一网络、统一数据库、统一GIS平台</div>
          </div> -->
        </div>
      </rSlide>
      <rSlide>
        <div class="box box3">
          <img src="../../assets/image/home/homebanner3.png" alt="" style="width: 100%;height: 100%">
          <!-- <div class="box-content">
            <div class="box-content-title">地质保障可视化和三维一体模型</div>
            <div class="box-content-jianjie">数据、信息、知识三层架构下的全息透明</div>
          </div> -->
        </div>
      </rSlide>
    </rSwiper>
  </div>
  <div class="home-style-phone">
    <rSwiper ref="swiperDOM" class="swiper" @loadEnd="funLoadEnd" @transitionend="funTransitionend" :autoPlay="false">
      <!-- :fast="true" -->
      <rSlide>
        <div class="box">
          <img src="../../assets/image/home/home_phone_carousel1.png" alt="" style="width: 100%;height: 100%">
          <!-- <div class="box-content">
            <div class="box-content-title">国内领先的</div>
            <div class="box-content-jianjie">
              <div class="box-content-jianjie-left">地</div>
              <div>学云产品与服务商</div>
            </div>
          </div> -->
        </div>
      </rSlide>
      <rSlide>
        <div class="box box2">
          <img src="../../assets/image/home/home_phone_carousel2.png" alt="" style="width: 100%;height: 100%">
          <!-- <div class="box-content">
            <div class="box-content-title">矿山安全生产</div>
            <div class="box-content-jianjie">
              <div class="box-content-jianjie-left">智</div>
              <div>慧监测管控分析</div>
            </div>
          </div> -->
        </div>
      </rSlide>
      <rSlide>
        <div class="box box3">
          <img src="../../assets/image/home/home_phone_carousel3.png" alt="" style="width: 100%;height: 100%">
          <!-- <div class="box-content">
            <div class="box-content-title">地质保障可</div>
            <div class="box-content-jianjie">
              <div class="box-content-jianjie-left">视</div>
              <div>化和三维一体模型</div>
            </div>
          </div> -->
        </div>
      </rSlide>
    </rSwiper>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { rSlide, rSwiper } from 'r-swiper'

const nowIndex = ref(0) // 当前下标

const swiperDOM = ref(null) // Dom元素

/**
 * 2023-12-18 08:52:05 Ywr
 * 初始化加载完成反馈函数
*/
const funLoadEnd = () => {
  console.log('loading - success');
  // changePage(1, true)
}

/**
 * 2023-08-12 19:23:06 Ywr
 * 切换页面完成反馈函数
 * @param {Number} i 当前下标
*/
const funTransitionend = (i) => {
  nowIndex.value = i
  console.log('当前下标', nowIndex.value)
}



</script>

<style scope lang="less">
@media screen and (max-width: 800px) {
  .home-style {
    display: none;
  }

  .home-style-phone {
    display: block;
  }
}



@media screen and (min-width: 800px) {
  .home-style {

    display: block;
  }

  .home-style-phone {
    display: none;
  }
}

.home-style {
  width: 100%;
  height: 626px;

  .box {
    width: 100vw;
    height: 626px;
    position: relative;
    // background: url('../../assets/image/home/homeCarousel1.png') no-repeat;

    .box-content {
      position: absolute;
      color: #fff;
      z-index: 999999;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -70%);
      font-family: 'PuHuiTi';
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .box-content-title {
        font-size: 60px;
        color: rgba(255, 255, 255, 1);
        font-weight: 700;
      }

      .box-content-jianjie {
        margin-top: 20px;
        font-size: 24px;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}

.home-style-phone {
  width: 100%;
  height: 496px;

  .box {
    width: 100vw;
    height: 496px;
    position: relative;
    // background: url('../../assets/image/home/homeCarousel1.png') no-repeat;

    .box-content {
      position: absolute;
      color: #fff;
      z-index: 999999;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -70%);
      font-family: 'PuHuiTi';
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .box-content-title {
        width: 100%;
        font-size: 36px;
        text-align: left;
        margin-left: 20px;
        letter-spacing: 3px;
        color: rgba(255, 255, 255, 1);
      }

      .box-content-jianjie {
        font-size: 24px;
        display: flex;
        align-items: baseline;
        color: rgba(255, 255, 255, 1);
        letter-spacing: 3px;

        .box-content-jianjie-left {
          font-size: 52px;
          color: rgba(35, 197, 208, 1);
        }
      }
    }
  }
}
</style>
